
import { FC, PropsWithChildren, useRef } from 'react';

import ApiClient from '@/utils/ApiClient';

import ApiContext from './ApiContext';

const ApiContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const _apiClient = useRef(ApiClient.instance.client);

  const { Provider } = ApiContext;

  return (
    <Provider value={{ client: _apiClient }}>
      {children}
    </Provider>
  );
};

export default ApiContextProvider;
